// rent - converted to lazy loading
const operatingCycles = () => import('@/pages/operatingCycles/index.vue')
const operatingCyclesForm = () => import('@/pages/operatingCycles/form.vue')
const operatingCyclesShow = () => import('@/pages/operatingCycles/show.vue')

const routes = [
  { path: 'operatingCycles', name: 'operatingCycles', component: operatingCycles },
  { path: 'operatingCycles/create', name: 'operatingCyclesCreate', component: operatingCyclesForm },
  { path: 'operatingCycles/:id', name: 'operatingCyclesShow', component: operatingCyclesShow },
  { path: 'operatingCycles/:id/edit', name: 'operatingCyclesEdit', component: operatingCyclesForm }
]

export default routes
